import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-home-page',
  templateUrl: './home-page.component.html',
  styleUrls: ['./home-page.component.css']
})
export class HomePageComponent implements OnInit {
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// C:/Users/Artem/Desktop/Programming/studio/creativeDigital/src/app/homepage/home-page.component.ts